import { trans } from '@spotahome/soyuz/client';

const MONTH_DAYS = 30;

const MIN_STAY = 'minStay';
const MAX_STAY = 'maxStay';

const STAY_CORRELATIONS = {
  [MIN_STAY]: {
    iconName: 'availability-min',
    limitKey: 'listing.availabilities.min-stay',
    noLimitKey: 'property_show.label.no_min_stay'
  },
  [MAX_STAY]: {
    iconName: 'availability-max',
    limitKey: 'listing.availabilities.max-stay',
    noLimitKey: 'property_show.label.no_max_stay'
  }
};

const getNMonths = days => Math.floor(days / MONTH_DAYS);

export const getHumanReadableStay = (timeInDays, type) => {
  const { limitKey, noLimitKey } = STAY_CORRELATIONS[type];

  return timeInDays
    ? trans(limitKey, {
        monthNumber: getNMonths(timeInDays),
        timeInDays
      })
    : trans(noLimitKey);
};

export const getHumanReadableMinStay = timeInDays =>
  getHumanReadableStay(timeInDays, MIN_STAY);

export const getHumanReadableMaxStay = timeInDays =>
  getHumanReadableStay(timeInDays, MAX_STAY);

export default {
  getHumanReadableStay,
  getHumanReadableMinStay,
  getHumanReadableMaxStay
};
